module.exports = __webpack_public_path__ + "img/Nrg.71623e50.png";